/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindAllQueryResponse, PromptsControllerFindAllQueryParams, PromptsControllerFindAll401, PromptsControllerFindAll403 } from "../../models/promptsController/PromptsControllerFindAll";

function getPromptsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/prompts` as const }  
  return res
}

/**
 * @summary Get all prompts with filtering and pagination
 * {@link /api/v1/prompts}
 */
export async function promptsControllerFindAll(params?: PromptsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerFindAllQueryResponse, ResponseErrorConfig<PromptsControllerFindAll401 | PromptsControllerFindAll403>, unknown>({ method : "GET", url : getPromptsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}